import { render, staticRenderFns } from "./FallRadarDetail.vue?vue&type=template&id=15ceadb6&scoped=true"
import script from "./FallRadarDetail.vue?vue&type=script&lang=js"
export * from "./FallRadarDetail.vue?vue&type=script&lang=js"
import style0 from "./FallRadarDetail.vue?vue&type=style&index=0&id=15ceadb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ceadb6",
  null
  
)

export default component.exports